module.exports = __webpack_public_path__ + "img/三门峡市.059de197.png";